module.exports = __webpack_public_path__ + "imgascvts/Information.49f7ae72.png";